import { Component } from '@angular/core';

@Component({
  selector: 'cx-onetrust-cookie-conf',
  templateUrl: './custom-onetrust-cookie-conf.component.html',
  styleUrls: ['./custom-onetrust-cookie-conf.component.scss'],
  standalone: false
})
export class CustomOnetrustCookieConfComponent {

}
